// extracted by mini-css-extract-plugin
export var banner = "_pu-0";
export var settingRow = "_pu-2";
export var titleIcon = "_pu-1";